import "../chunk-BUSYA2B4.js";
import { buildErrorThrower } from "@clerk/shared/error";
const errorThrower = buildErrorThrower({ packageName: "@clerk/nextjs" });
export {
  errorThrower
};
//# sourceMappingURL=errorThrower.js.map